
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(function() {
	'use strict';
	class Rave2network {
		get config(){
			return {
				'type':'Network',
				'doesNotSupportAnnotations': true,
				'doesNotSupportCustomGroupAction': true,
				'supportsMaintainAxisScale':false,
				'propertiesToSetBeforeData': [
					'widget.data.truncate'
				],
				'listenForPropChanges': [
					'widget.legend.size'
				],
				'slots':{
					'categories':{
						'icon':'from'
					},
					'series':{
						'icon':'to'
					},
					'values':{
						'icon':'lineweight'
					},
					'repeatHorizontal':{
						'icon':'multiplier_h',
						'sort':'asc'
					},
					'repeatVertical':{
						'icon':'multiplier_v',
						'sort':'asc'
					}
				},
				'propertyPrefixes': {
					'dataPoint': 'labels',
					'categories': 'widget.legend',
					'series': 'widget.legend',
					'legend':'widget.legend',
					'row': 'widget.repeatVertical.labels',
					'column': 'widget.repeatHorizontal.labels'
				},
				'groupedProperty': {
					'widget.legend.color': ['widget.legend.titleColor'],
					'widget.legend.font': ['widget.legend.titleFont']
				},
				'isRecommendable':false,
				'properties': {
					'widget.data.truncate': {
						active: false,
						defaultValue: true
					},
					'effect.duration': {
						'active': false
					},
					'network.nodes.size.min': {
						'active': false
					},
					'network.nodes.size.max': {
						'active': false
					},
					'widget.legend.size': {
						'active': false
					},
					'labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 8
					},
					'widget.legend.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.titleColor': {
						'colorClass': true,
						'active': true
					},
					'widget.repeatHorizontal.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.repeatVertical.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					}
				},
				config:{
					'include':[
						'widget.data.truncate',
						'widget.iterator',
						'widget.legend.display',
						'widget.legend.position',
						'labels.visible',
						'effect.duration',
						'optimizeSize',
						'network.nodes.size.min',
						'network.nodes.size.max',
						'network.links.color',
						'widget.legend.color',
						'widget.legend.splitter',
						'widget.legend.font',
						'widget.legend.titleFont',
						'widget.legend.titleColor',
						'widget.legend.swatch.symbol.default',
						'labels.font',
						'labels.color',
						'widget.repeatHorizontal.labels.color',
						'widget.repeatVertical.labels.color',
						'widget.repeatHorizontal.labels.font',
						'widget.repeatVertical.labels.font',
						'color.from',
						'color.to',
						'widget.legend.size',
						'widget.legend.titleVisible'
					],
					'exclude':[
					]

				},
				'usages':[
					'Relationships'
				],
				'colorPalettes': {
					'single':{
						'color.to': {
							id: 'defaultPaletteIndex',
							labelId: 'propToColor',
							defaultColorIndex: 0
						},
						'color.from': {
							id: 'fromColor',
							labelId: 'propFromColor',
							defaultColorIndex: 1
						}
					}
				}
			};
		}
	}
	return Rave2network;
});
